// extracted by mini-css-extract-plugin
module.exports = {"no-data":"NoData_no-data__lSzBG"};